import React from 'react';
import './search.scss';

export function Search() {
  return (
    <div className="hero_home version_1">
      <div className="content">
        <h3>Найти врача!</h3>
        <p>Введите имя врача либо название услуги.</p>
        <form method="get" action="/search-results">
          <div id="custom-search-input">
            <div className="input-group">
              <input
                type="text"
                name="keyword"
                className="search-query"
                placeholder="Например, Имя, Услуга..."
              />
              <button type="submit" className="btn_search">
                <i className="icon-search" />
                <span className="text-search">Поиск</span>
              </button>
            </div>
            <ul>
              <li>
                <input
                  type="radio"
                  id="all"
                  name="area"
                  value="all"
                  defaultChecked
                />
                <label htmlFor="all">Всё</label>
              </li>
              <li>
                <input type="radio" id="doctor" name="area" value="doctor" />
                <label htmlFor="doctor">Врачи</label>
              </li>
              <li>
                <input type="radio" id="service" name="area" value="service" />
                <label htmlFor="service">Мед. услуги</label>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Search;
